import config from 'constants/config'
import { useIsMobileDevice } from './useIsMobileDevice'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'

export function useRenderWhatsApp(region: string) {
  const isMobileUserAgent = useIsMobileDevice()
  const hideWhatsApp = !isMobileUserAgent

  return config.WHATS_APP_NUMBER && !hideWhatsApp && isEnabledForFeature(config.WHATS_APP_COUNTRIES, region)
}
